import React, { Component, Fragment } from 'react';
import { Row, Col, Tab, Nav, Accordion, OverlayTrigger, Tooltip } from 'react-bootstrap';

import Auth from '../Auth/Auth';
import OnCall from '../Components/SmartPanelTabs/OnCall';
import SearchSub from '../Components/SmartPanelTabs/SearchSubs';
import Manager from '../Components/SmartPanelTabs/Manager';
import UPD from '../Components/SmartPanelTabs/UPD';
import Namespace from '../Components/SmartPanelTabs/Namespace';
import { setSmartClickTracker } from '../Helpers/FeatureHelpers';
import UsefulDocuments from './SmartPanelTabs/UsefulDocuments';

import './SmartPanel.scss';

const auth = new Auth();
const smartTabs = [
    {
        name: 'namespace',
        icon: 'fas fa-globe-americas',
        Tooltip: 'Client / Namespace Search'
    },
    {
        name: 'onCall',
        icon: 'fas fa-headset',
        Tooltip: 'On Call Schedule'
    },
    {
        name: 'Suggested',
        icon: 'fas fa-file-alt',
        Tooltip: 'Suggested Links and Items'
    },
    {
        name: 'SearchSubs',
        icon: 'fab fa-searchengin',
        Tooltip: 'Search Subscriptions'
    }, {
        name: 'Notifications',
        icon: 'fas fa-bullhorn',
        Tooltip: 'Announcements'
    }, {
        name: 'Manager',
        icon: 'fas fa-users',
        Tooltip: 'Manager'
    }, {
        name: 'UPD',
        icon: 'fas fa-wrench',
        Tooltip: 'Upgrade Schedule'
    }
];

export default class SmartPanel extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this._isMounted = false;

        this.state = {
            target: '',
            namespace: '',
            suggestedLinks: [],
            Announcements: [],
            smartPanelTab: "namespace",
            UPDNamespace: null,
            activeIndex: 0,
            searchSubs: []
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.getSuggestedLinks();
        this.getAnnouncements();
        setSmartClickTracker(this);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.target !== this.props.target && (this.props.target === "All" || this.props.target === "D365" || this.props.target === "Jira")) {
            this.setState({
                smartPanelTab: "namespace"
            });
        }

        if (prevProps.defaultTab !== this.props.defaultTab) {
            this.setState({
                smartPanelTab: this.props.defaultTab
            });
        }

        if (prevProps.passedNamespace !== this.props.passedNamespace) {
            this.passedNamespace(this.props.passedNamespace);
        }
    }

    passedNamespace(namespace) {
        this.setState({
            namespace: namespace[0]
        });
    }

    async getSuggestedLinks() {
        let accessToken = await auth.getToken();
        let keywordArr = new Set();
        fetch('/api/SuggestedLink', {
            method: "GET",
            headers: {
                'Authorization': "Bearer " + accessToken,
                withCredentials: true,
                crossDomain: true
            }
        }).then(response => {
            if (response.status !== 200) {
                let payload = [{
                    status: response.status,
                    rawmsg: response.statusText,
                    cleanmsg: response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp: Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                };
            }
            return response.json();
        }).then(data => {
            if (data && data.length > 0) {
                data[0].forEach(element => {
                    //split keywords and pull out unique
                    let KeywordsSplit = element.Keywords.split(",");
                    KeywordsSplit.forEach(keyword => {
                        keywordArr.add(keyword.trim());
                    });
                });

                this._isMounted && this.setState({
                    suggestedLinks: data[0],
                    keywordArr: keywordArr
                });
            }
        }).catch((error) => {
            window.apiError(error);
        });
    }

    async getAnnouncements() {
        let accessToken = await auth.getToken();

        fetch('/api/Announcements', {
            method: "GET",
            headers: {
                'Authorization': "Bearer " + accessToken,
                withCredentials: true,
                crossDomain: true
            }
        }).then(response => {
            if (response.status !== 200) {
                let payload = [{
                    status: response.status,
                    rawmsg: response.statusText,
                    cleanmsg: response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp: Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                };
            }
            return response.json();
        }).then(data => {
            if (data[0] && data[0].length > 0) {
                let ErrorArr = data[0].filter(el => el.isActive === true && el.Title.indexOf("Issues") > -1);
                if (ErrorArr.length > 0) {
                    this.props.ErrorNotification(ErrorArr);
                }

                this._isMounted && this.setState({
                    Announcements: data[0].sort(function (a, b) {
                        return new Date(parseInt(a.SortOrder)) - new Date(parseInt(b.SortOrder));
                    })
                });
                for (var i = 0; i < data[0].length; i++) {
                    if (data[0][i].Urgent === true) {
                        this._isMounted && this.setState({
                            smartPanelTab: 'Notifications'
                        });
                    }
                }

            }
        }).catch((error) => {
            window.apiError(error);
        });
    }

    initQuickView(link, title, cerebro) {
        this.props.initQuickView(link, title);
    }

    render() {

        return (
            <div className="smart-panel">
                <Tab.Container id="left-tabs-example" defaultActiveKey="namespace" activeKey={this.state.smartPanelTab}>
                    <Row>
                        <Col sm={12}>
                            <div className="options">
                                {smartTabs.map((items, index) =>
                                    <OverlayTrigger
                                        key={index}
                                        placement={"bottom"}
                                        overlay={
                                            <Tooltip id={`tooltip-top`}>
                                                {items.Tooltip}
                                            </Tooltip>
                                        }
                                    >
                                        <Nav.Link key={index} className={this.state.smartPanelTab === items.name ? "option-link-container active" : "option-link-container"} data-track="true" name={items.name} eventKey={items.name} onClick={() => this.setState({ smartPanelTab: items.name })}><i className={items.icon}></i></Nav.Link>
                                    </OverlayTrigger>

                                )}

                                <OverlayTrigger
                                    placement={"bottom"}
                                    overlay={
                                        <Tooltip id={`tooltip-top`}>
                                            The Smart Panel! This panel is meant to make your life easier with helpful widgets that get you info faster.
                                        </Tooltip>
                                    }
                                >
                                    <span className="float-right m-2"><i className="far fa-question-circle tooltip-icon"></i></span>
                                </OverlayTrigger>
                            </div>
                        </Col>
                        <Col sm={12} style={{ zIndex: 10 }}>
                            <Tab.Content>
                                <Tab.Pane eventKey="namespace">
                                    {this.state.smartPanelTab === "namespace" && (
                                        <Namespace passedNamespace={this.state.namespace} switchSmartPanelTab={(smartPanelTab, namespace) => { this.setState({ activeIndex: smartPanelTab, smartPanelTab: smartPanelTab, UPDNamespace: namespace }); }} />
                                    )}
                                </Tab.Pane>
                                <Tab.Pane eventKey="onCall">
                                    {this.state.smartPanelTab === "onCall" && (
                                        <Fragment>
                                            <div className="smart-panel-title">
                                                <p className="pl-3 mb-0">
                                                    On Call Schedule
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                This panel displays the On Call schedule
                                                            </Tooltip>
                                                        }>
                                                        <i className="far fa-question-circle tooltip-icon"></i>
                                                    </OverlayTrigger>
                                                </p>
                                                <p style={{ fontSize: "12px", marginTop: "6px" }} className="pl-3">View full schedule <a href="https://avayareports.ceridian.com/OnCallv2/default.asp" target="_blank" rel="noopener noreferrer">here.</a>
                                                    <br />View On Call Program details and additional links <a href="https://ceridian.atlassian.net/l/cp/ei4z2Tav" target="_blank" rel="noopener noreferrer">here.</a>
                                                    <br />For questions about the On Call schedule, please contact <a href="mailto:karen.fanelli@ceridian.com"> Karen Fanelli.</a>
                                                </p>
                                            </div>
                                            <OnCall />
                                        </Fragment>
                                    )}
                                </Tab.Pane>
                                <Tab.Pane eventKey="Suggested">
                                    {this.state.smartPanelTab === "Suggested" && (
                                        <UsefulDocuments documentLinks={this.state.suggestedLinks} />
                                    )}
                                </Tab.Pane>
                                <Tab.Pane eventKey="SearchSubs">
                                    <SearchSub />
                                </Tab.Pane>
                                <Tab.Pane eventKey="Notifications">
                                    <div className="smart-panel-title">
                                        <p className="pl-3 mb-0">
                                            Announcements
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip>
                                                        Announcements from the great people of Fetch
                                                    </Tooltip>
                                                }>
                                                <i className="far fa-question-circle tooltip-icon"></i>
                                            </OverlayTrigger>
                                        </p>
                                        <span className="pl-3">Things to be aware of</span>
                                    </div>
                                    {this.state.Announcements.map((items, index) =>
                                        <div key={index} className="annoucement-item">
                                            <h6>{items.Title}</h6>
                                            <p dangerouslySetInnerHTML={{ __html: items.Details }}></p>
                                        </div>
                                    )}
                                </Tab.Pane>
                                <Tab.Pane eventKey="Manager">
                                    {this.state.smartPanelTab === "Manager" && (
                                        <Manager initQuickView={(link, title) => this.initQuickView(link, title)} selectedAccount={(namespace) => { this.passedNamespace(namespace); this.setState({ smartPanelTab: "namespace" }) }} />
                                    )}
                                </Tab.Pane>                                
                                <Tab.Pane eventKey="UPD">
                                    {this.state.smartPanelTab === "UPD" && (
                                        <UPD UPDNamespace={this.state.UPDNamespace} />
                                    )}
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </div>

        );
    }
}